<template>
    <window :title="title">
        <Material
            :contents-json="baseJson"
            :autoplay-option="false"
            :readdir="dir"
        >
            <template #next-contents>
                <router-link
                    class="btn btn-outline-dark"
                    :to="`/story/${contentsName}`"
                    @click="setHistory"
                    >ストーリー編へ進む</router-link
                >
            </template>
        </Material>
    </window>
</template>

<script>
import Material from "@/components/material";

export default {
    name: "base-contents",
    components: {
        Material,
    },
    data() {
        return {
            title: "基礎知識編",
            dir: `base_${this.$route.params.contents}`,
            contentsName: this.$route.params.contents,
        };
    },
    computed: {
        baseJson() {
            let res = require(`@/assets/base.json`);
            // 対応するディレクトリのスライドjsonデータを取得
            let json = res.find((item) => item.dir == this.dir);
            return json;
        },
    },
    mounted() {
        this.$store.commit("setLastTime", {
            contents:
                this.$route.params.contents.substring(0, 1).toUpperCase() +
                this.$route.params.contents.substring(1),
            page: "base",
        });
    },
    methods: {
        setHistory() {
            this.$store.commit("setCompleteStatus", {
                contents:
                    this.$route.params.contents.substring(0, 1).toUpperCase() +
                    this.$route.params.contents.substring(1),
                page: "base",
                isComplete: true,
            });
        },
    },
};
</script>